/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'
import { isCanlan } from '@sportninja/common/utils/customer-name'
import { Tooltip } from 'antd'
import React from 'react'
import InfoCircleIcon from 'src/components/icons/InfoCircleIcon'
import PermissionIcon from 'src/components/icons/PermissionIcon'
import StarIcon from 'src/components/icons/StarIcon'
import Text from 'src/components/ts-components/Text'

const orgLabel = isCanlan ? 'Leagues' : 'Organizations'
const compLabel = isCanlan ? 'Seasons' : 'Competitions'

const TooltipContent: React.FC = () => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 4px;
    `}
  >
    <div
      css={css`
        display: flex;
        align-items: flex-start;
        gap: 8px;
      `}
    >
      <PermissionIcon
        size={16}
        color={colors.PRIMARY}
        style={{ flexShrink: 0, marginTop: 2 }}
      />
      <Text variant='paragraphXSmall' weight='regular' color={colors.NEUTRAL_0}>
        <strong>Permission</strong> &mdash; {orgLabel}, {compLabel}, and Teams
        you are a member of
      </Text>
    </div>
    <div
      css={css`
        display: flex;
        align-items: flex-start;
        gap: 8px;
      `}
    >
      <StarIcon
        size={16}
        color={colors.PRIMARY}
        style={{ flexShrink: 0, marginTop: 2 }}
      />
      <Text variant='paragraphXSmall' weight='regular' color={colors.NEUTRAL_0}>
        <strong>Following</strong> &mdash; {orgLabel}, {compLabel}, and Teams
        you are following
      </Text>
    </div>
    <a
      href='https://support.sportninja.com/'
      target='_blank'
      rel='noopener noreferrer'
      css={css`
        color: ${colors.INFO_300};
        font-size: 12px;
        &:hover {
          text-decoration: underline;
          color: ${colors.INFO_200};
        }
      `}
    >
      Learn more
    </a>
  </div>
)

const MembershipTypeInfoLabel: React.FC = () => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 4px;
      `}
    >
      <Text variant='paragraphSmall' weight='regular' color={colors.NEUTRAL_0}>
        Membership Type
      </Text>
      <Tooltip
        title={<TooltipContent />}
        placement='top'
        overlayInnerStyle={{
          backgroundColor: colors.SECONDARY_300,
          border: `1px solid ${colors.SECONDARY_200}`,
          borderRadius: 8,
          padding: 12,
          maxWidth: 320,
        }}
      >
        <span
          css={css`
            display: inline-flex;
            cursor: pointer;
          `}
        >
          <InfoCircleIcon size={16} color={colors.NEUTRAL_50} />
        </span>
      </Tooltip>
    </div>
  )
}

export default MembershipTypeInfoLabel
